import React, { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";

import Button from "../../../UI/Button/Button";
import EmptyState from "../../../UI/State/EmptyState";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { ExportToCsv } from "export-to-csv";

import { faDownload, faChartBar } from "@fortawesome/free-solid-svg-icons";
import "./AnalyticsTable.scss";

const AnalyticsTable = (props) => {

    const intl = useIntl();
    const [data, setData] = useState([]);
    const sizePerPage = 10;

    useEffect(() => {
        if (props.analytics) {
            setData(props.analytics)
        }
    }, [props.analytics]);

    const dateFormatter = (date) => {
        return intl.formatDate(date, { year: "numeric", month: "short", day: "numeric" })
    }

    const noDataIndication = () => {
        let display =
            <EmptyState
                icon={faChartBar}
                text={intl.messages.analyticsNoDataFound}
                progress={props.progress}
            />;
        return display;
    }

    const columns = [
        {
            text: intl.messages.analyticsDate,
            dataField: "date",
            formatter: dateFormatter,
        },
        {
            text: "Administrative API (Unit)",
            dataField: "administration"
        },
        {
            text: "Resources API (Unit)",
            dataField: "resources"
        },
        {
            text: "WebRTC (Min)",
            dataField: "webrtc_minutes"
        },
        {
            text: "Storage (Bytes)",
            dataField: "storage"
        },
        {
            text: "Turn (Bytes)",
            dataField: "turn",
            hidden: !props.showTurn
        }
    ];

    const customTotal = (from, to, size) => (
        <span className="ml-5 mt-2 text-muted float-left">
            {intl.formatMessage({ id: "analyticsTotalPage" }, { from: from, to: to, size: size })}
        </span>
    );

    const paginationOption = {
        totalSize: data.length,
        sizePerPage: sizePerPage,
        showTotal: (data.length > sizePerPage),
        hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
        hideSizePerPage: (data.length < sizePerPage), //You can hide the size per page dropdown.
        paginationTotalRenderer: customTotal,
        sizePerPageList: [{
            text: "10 " + intl.messages.analyticsRows, value: 10
        }, {
            text: "20 " + intl.messages.analyticsRows, value: 20
        }, {
            text: intl.messages.analyticsAll, value: data.length
        }]
    };

    const exportAllToCSV = () => {
        const options = {
            fieldSeparator: ";",
            quoteStrings: '"',
            decimalSeparator: ".",
            showLabels: true,
            showTitle: false,
            filename: "all_analytics",
            useTextFile: false,
            useBom: true,
            useKeysAsHeaders: true,
        };
        const csvExporter = new ExportToCsv(options);
        csvExporter.generateCsv(props.exportableAnalytics);
    }

    return (
        <div className="card border-0">
            <div className="card-body text-center">
                {/* <h3 className="text-muted mt-2 mb-4">{intl.messages.analyticsTableTitle}</h3> */}
                <Button
                    id="analytics-exportAll-btn"
                    className="btn-submit mb-2 float-right"
                    onClick={exportAllToCSV}
                    icon={faDownload}
                    label={intl.messages.exportToCsv}
                />
                
                <BootstrapTable
                    id="bstable"
                    keyField="date"
                    data={data}
                    columns={columns}
                    //bordered={false}
                    headerClasses="bg-gray text-white"
                    wrapperClasses="table-responsive"
                    striped
                    pagination={paginationFactory(paginationOption)}
                    noDataIndication={noDataIndication}
                />
                
            </div>
        </div>
    );
}

AnalyticsTable.defaultProps = {
    progress: false,
    showTurn: false
}

AnalyticsTable.propTypes = {
    analytics: PropTypes.array,
    exportableAnalytics: PropTypes.array,
    progress: PropTypes.bool,
    showTurn: PropTypes.bool
};

export default AnalyticsTable;